export default {
  visitorMode: true,
  GeoKeys: '5Y6BZ-VLPEI-SJ5GP-ULXI2-2JDIK-D6FTJ',
  primaryColor: '#F03867'
}
